import { HTTPService, HelperService, DataService, DateService } from 'app/services';
import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
  selector: 'app-tech-flag-dialog',
  templateUrl: './tech-flag-dialog.component.html',
  styleUrls: ['./tech-flag-dialog.component.scss'],
})
export class TechFlagDialogComponent implements OnInit {
  data: any = {};
  service: any = {};
  estimateId: string = '';
  serviceId: string = '';
  flagNotes: string = '';
  isProcessingResolved: boolean = false;
  isProcessingSave: boolean = false;
  isProcessing: boolean = false;
  isLoading: boolean = false;
  role: string = '';
  adminCreatedBy: any = {
    name: '',
    date: '',
    time: '',
    datetime: '',
  };
  techCreatedBy: any = {
    name: '',
    date: '',
    time: '',
    datetime: '',
  };
  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dataService: DataService,
    private dialogService: DialogService,
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.role = this.helperService.getCompany().role;

    this.data = this.dConfig.data;
    this.serviceId = this.data.serviceId;
    this.estimateId = this.data.estimateId;

    if (this.estimateId && this.serviceId) {
      this.getOrderServiceById(this.estimateId, this.serviceId);
    }
  }

  getOrderServiceById(estimateId, serviceId) {
    this.isLoading = true;
    this.httpService.getOrderService(estimateId, serviceId).then(
      (data: any) => {
        this.service = data.service;
        this.isLoading = false;
        if (this.service) {
          this.setDateTime(this.service);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  setDateTime(service) {
    if (service.techFlag && service.isTechFlag) {
      if (service.techFlag.techUpdatedAt) {
        service.techFlag.techUpdatedAt = this.dateService.getCurrentDateTimeTz(new Date(service.techFlag.techUpdatedAt).getTime());
        this.techCreatedBy.date = this.dateService.formatDate(service.techFlag.techUpdatedAt, datetimeFormat.mmmdyyhhmmaa);
      }

      if (service.techFlag.adminUpdatedAt) {
        service.techFlag.adminUpdatedAt = this.dateService.getCurrentDateTimeTz(new Date(service.techFlag.adminUpdatedAt).getTime());
      }
      service.techFlag.adminUpdatedAt = this.dateService.getCurrentDateTimeTz(new Date(service.techFlag.adminUpdatedAt).getTime());
      this.adminCreatedBy.date = this.dateService.formatDate(service.techFlag.adminUpdatedAt, datetimeFormat.mmmdyyhhmmaa);
    }
  }

  saveTechFlag() {
    if (this.isProcessingSave) {
      return;
    }
    this.isProcessingSave = true;
    if (this.serviceId && this.estimateId) {
      const flag = {
        notes: this.service.techFlag.adminNotes,
        action: 'updated',
      };
      this.httpService.updateTechFlag(this.estimateId, this.serviceId, flag, 'admin').then(
        ({ service }: any) => {
          this.dynamicDialogRef.close(service);
          this.dynamicDialogRef.close({ data: service });
          this.getOrderServiceById(this.estimateId, this.serviceId);
          this.isProcessingSave = false;
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  resolveTechFlag() {
    if (this.isProcessingResolved) return;

    this.isProcessingResolved = true;
    const flag = {
      notes: this.service.techFlag.adminNotes,
      flagStatus: 'resolved',
    };

    this.httpService.updateTechFlag(this.estimateId, this.serviceId, flag, 'admin').then(
      (estimate: any) => {
        this.getOrderServiceById(this.estimateId, this.serviceId);
        this.dynamicDialogRef.close(estimate.service);
        this.isProcessingResolved = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleChange(value: any) {
    this.flagNotes = value;
    this.service.techFlag.adminNotes = this.flagNotes;
  }
  onNotesClear() {
    this.flagNotes = null;
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }
}
